import React, { useState ,useEffect} from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { addStudent } from '../../service/apiService';
import { getStudents } from '../../service/apiService';
import './Admission.css';

function Admission({ user }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    course: '',
    admission_date: '',
    address: '',
    remarks: '',
  });
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      ...formData,
      created_by: user.id,
    };
    const res = await addStudent(data);
    setLoading(false);
    if (res.status === 'success') {
      alert('Student added successfully!');
      setFormData({
        name: '',
        phone: '',
        email: '',
        course: '',
        admission_date: '',
        address: '',
        remarks: '',
      });
    } else {
      alert('Error: ' + res.message);
    }
  };
const fetchStudents = async () => {
  try {
    const res = await getStudents();

    console.log("API RESPONSE:", res); // debug

    if (res.status === 'success') {
      setStudents(res.data); // ✅ ONLY this
    } else {
      setStudents([]);
    }
  } catch (err) {
    console.log(err);
  }
};

useEffect(() => {
  fetchStudents();
}, []);

const indexOfLast = currentPage * itemsPerPage;
const indexOfFirst = indexOfLast - itemsPerPage;

const currentStudents = students.slice(indexOfFirst, indexOfLast);

const totalPages = Math.ceil(students.length / itemsPerPage);

  return (
    <div className="admission-page">
      <h3 className="mb-4">New Student Admission</h3>

      <Card className="shadow-sm p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Student Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Course / Program</Form.Label>
                <Form.Control
                  type="text"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Admission Date</Form.Label>
                <Form.Control
                  type="date"
                  name="admission_date"
                  value={formData.admission_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  type="text"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  placeholder="Any remarks (optional)"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </Form.Group>

          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Admission'}
          </Button>
        </Form>
      </Card>
      <Card className="shadow-sm p-4 mt-4">

  <h5>Students List</h5>

  <div className="table-responsive">

    <table className="table table-bordered table-hover">

      <thead className="table-dark">
        <tr>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
          <th>Course</th>
          <th>Admission Date</th>
        </tr>
      </thead>

      <tbody>

        {currentStudents.length > 0 ? (
          currentStudents.map((item) => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>{item.course}</td>
              <td>{item.admission_date}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5" className="text-center">
              No students found
            </td>
          </tr>
        )}

      </tbody>

    </table>

  </div>
  <div className="d-flex justify-content-center align-items-center mt-3 gap-3">

  <Button
    variant="light"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
    style={{ fontSize: '20px', fontWeight: 'bold' }}
  >
    ‹
  </Button>

  <span>
    {currentPage} / {totalPages || 1}
  </span>

  <Button
    variant="light"
    disabled={currentPage === totalPages || totalPages === 0}
    onClick={() => setCurrentPage(currentPage + 1)}
    style={{ fontSize: '20px', fontWeight: 'bold' }}
  >
    ›
  </Button>

</div>

</Card>
    </div>
  );
}

export default Admission;
